<template>
  <div class="layer_section-container">
    <div class="layer-header">
      <h1 class="header-title">
        배송지 목록
      </h1>
    </div>
    <div class="layer-content">
      <div class="cart-popup__item-info">
        <div class="form-wrapper address-book">
          <input
            v-model="searchedName"
            type="text"
            name="searchText"
            placeholder="받는 분, 주소명 입력"
            title="검색할 주소 입력"
            autocomplete="off"
            class="form_input"
            @keyup.enter="searchDeliveryList"
            @focus="onFocusSearchInput"
            @blur="onBlurSearchInput"
          >
          <span class="btn-book">
            <button
              id="searchButton"
              type="submit"
              class="btn_default-c medium"
              @click="searchDeliveryList"
            ><span>검색</span></button>
            <button
              id="viewAllButton"
              type="button"
              class="btn_default-f medium"
              @click="showAllDeliveryList"
            >전체보기</button>
          </span>
        </div>
        <div class="align-area">
          <p class="my-Shipping-txt align-item left">
            나의 배송지(<span id="shippingListCount">{{ delList.length }}</span>)
          </p>
          <!-- <span class="box-btns"><a
            :href="deliveryListManagement"
            target="_blank"
            class="btn_default-d"
          >배송지관리</a></span> -->
        </div>
        <div
          id="myShippingList"
          class="table-wrapper my-Shipping-list"
        >
          <table class="tbl-type1">
            <caption>이름, 주소, 선택항목 제공</caption>
            <colgroup>
              <col style="width:75%">
              <col style="width:25%">
            </colgroup>
            <tbody>
            <tr
              v-for="(del, index) in delList"
              :key="index"
            >
              <td>
                <p>{{ del.name }}</p>
                <p>[{{ del.defaultAddress.postalCode }}]
                  {{ del.defaultAddress.formattedAddress }}</p>
              </td>
              <td class="right">
                <button
                  type="button"
                  class="link-btn"
                  @click="chooseDeliveryLocation(del)"
                >
                  선택
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="my-Shipping-info">
          <ul class="list-type2">
            <li>배송지 수정/삭제 등의 관리는 <span
              class="pot-basic"
            ><a
              target="_blank"
              :href="deliveryListManagementUrl"
            >
              마이페이지 &gt; 나의쇼핑정보 &gt; 배송지관리</a></span> 에서 하실 수 있습니다</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="align-box size-auto">
      <button
        type="button"
        class="btn-modal_close"
        @click="onDispose"
      >
        닫기
      </button>
    </div>
  </div>

</template>

<script>
import greedyKeyReactor from '@/utils/greedy-key-reactor';
export default {
  name: 'PopupDeliveryList',
  props: {
    deliveryList: {
      type: Array,
      default: () => [],
    },
    deliveryListManagementUrl: {
      type: String,
      default: `https://${process.env.SSO_HOST}/my-account/address-book`,
    },
  },
  data() {
    return {
      delList: [],
      searchedName: '',
    };
  },
  computed: {
  },
  created() {
    this.delList = this.deliveryList;
  },
  methods: {
    onDispose() {
      this.$emit('dispose', 'get out!');
    },
    onFocusSearchInput() {
      greedyKeyReactor.dictate();
    },
    onBlurSearchInput() {
      greedyKeyReactor.liberate();
    },
    searchDeliveryList() {
      this.delList = [];
      if (this.searchedName === '') {
        this.showAllDeliveryList();
      } else {
        this.deliveryList.forEach((n) => {
          if (n.name.indexOf(this.searchedName) !== -1
            || n.defaultAddress.formattedAddress.indexOf(this.searchedName) !== -1) {
            this.delList.push(n);
          }
        });
      }
    },
    showAllDeliveryList() {
      this.delList = [];
      this.delList.push(...this.deliveryList);
    },
    chooseDeliveryLocation(e) {
      this.$emit('set-delivery-location', e);
      this.$emit('dispose', 'get out!');
    },
  },
};
</script>

<style>
</style>
